import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AuthenticationService } from "../../../pages/services/authentication.service";
import { ValidRoles } from "../../enums";

export const HasRoleGuard: CanActivateFn = async ( route: ActivatedRouteSnapshot ) => {
  const auth: AuthenticationService = inject( AuthenticationService );
  const validRoles = route.data['roles'] as ValidRoles[];
  return auth.hasAtLeastOneRole( validRoles );
}
